export default __webpack_public_path__ + "static/media/banner-mobile.5dd13f2c.png";